import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'

import BlogSidebar from '../../components/BlogSidebar'

import Calendar from '../../images/Calendar.svg'
import Divider from '../../images/Divider.svg'
import Fill from '../../images/Fill.svg'
import Wave from '../../images/Wave.svg'
import WaveB from '../../images/WaveB.svg'

export const query = graphql`
  query blogtwo {
    blogtwobanner: file(relativePath: {eq: "BlogTwo.jpg"}) {
      blogtwobannerchild: childImageSharp {
      sizes(quality: 100, maxWidth: 1000, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
      }
    },
}
`

const BlogOne = ({data:{blogtwobanner}}) => (
  <section>
    <article className='blogcontainer'>
      <div className='container'>
        <div className='full-Width' style={{alignItems:'flex-start'}}>
          <div className='half-Width-75 paddingRight mobBottommargin'>
            <div style={{display:'block'}}>
            <p className='smallerHone'>Blog</p>
            <img src={Divider} alt="Nisadhya - Divider" style={{margin:'0.75rem 0'}}/>
            <h1 className='smallerHone'><span className='gradient'>Why is Content Marketing important?</span></h1>
            <p style={{display: 'flex', alignItems: 'center', margin:'0.75rem 0 0 0'}}>
            <img src={Calendar} alt="Nisadhya - Calendar" style={{width:'1.25rem', marginRight:'.5rem'}}/>8<sup>th</sup> March 2019
            </p>
            <Img className='blogimg' sizes={blogtwobanner.blogtwobannerchild.sizes} alt="Why is Content Marketing important"/>
            <p className='blogpara'>Content Marketing is a strategic marketing method that consists of creating and sharing valuable and relevant content, to attract potential clients,
            convert them into customers and eventually engage them in your service or product.
            Content marketing is not only about advertising, it is about generating awareness about who you are, what you do and what you can offer. So, that people trust you and your business.</p>
            <p>In today’s fast-paced digital world, online marketing has transformed the way businesses interact with their clients. Businesses now have to become more interactive and engaging with their
            clients in order to gain trust and loyalty in return. When it comes to building brand awareness, connecting with your audience, building trust and presenting your service,
            there is no approach more effective other than content marketing.</p>
            <p>Content marketing is the foundation whereupon businesses work.
            From the story told on social sites, to important reading materials on the web, to video, audio, and images, content is being delivered. Nowadays, it is important to give out advice,
            engaging stories and information that is of genuine use or interest to the audience. Content marketing has become one of the most widespread and effective marketing methods of
            businesses around the globe to gain reach. Below are some of the reasons why content marketing is necessary for your business:</p>
            <p style={{marginBottom:'0'}}>
              <ul>
                <li><strong>It Improves Brand Loyalty:</strong><br/>
                A good content attracts genuine and interested customers.
                When you give your customers valued and relevant content about your business, services or products, it is more likely that they will invest their time in your business.
                One of the main reason audiences turn into customers is because they believe you are a professional and trust in your services.
                This is why companies write blogs, create engaging subjects, and share various interactive contents through online.
                All of these things help to position the business as an expert, which leads to trust in the brand name.
                Content marketing is the right way to aware people and, prove that you are an expert and can be trusted.
                </li>
                <li><strong>Generates Leads:</strong><br/>
                When your content is well written and properly executed it will begin attracting potential customers and generate leads.
                The most important thing to keep in mind is the relevance of the content.
                When the content is relevant, catchy, interesting and useful, people get interested and they tend to find out more about your business, which will eventually lead them to turn into customers.
                It means you can figure out your customer’s preferences and get to know their needs and choices better.
                A good content can initiate discussion and get everyone talking, which will help in generating new leads
                </li>
                <li><strong>Increase Your Followers On Social Media:</strong><br/>
                Content marketing and social media are intertwined with each other. When a good content is distributed in social media, it starts circulating among the targeted audiences.
                The interested audiences will start following you on your social media, which will eventually lead them into seeing your content frequently, and start trusting your business name.
                When an interesting content is circulated, the numbers of followers on social media increases which might lead them in turning into future customers.
                </li>
                <li><strong>Improves Search Engine Optimization (SEO)</strong><br/>
                Search engine optimization (SEO) is the process of affecting the visibility of a website in a search engine’s results.
                Good quality content is very beneficial for SEO.
                The benefit of posting valuable, relevant and interesting articles, images, videos, or any kind of content, is that it helps in boosting your SEO.
                When the content is relevant, interesting and something new it does not only get read by interested customers but it will also gain you more credibility by Google,
                which will increase your place higher in the search engine result page.
                It will make your business look trustworthy among the customers and make them interested.
                </li>
                <li><strong>Cheaper Than Traditional Marketing:</strong><br/>
                Content marketing specifically, is much cheaper than traditional marketing and generates significantly more leads.
                Content marketing plays an important role in generating new leads and attracting new customers.
                Most of the people get interested in a business through the content they share.
                So, the key to a successful marketing strategy is quality content, which is extremely low cost and equally effective.
                </li>
              </ul>
            </p>
            </div>
          </div>
          <div className='half-Width-25'>
            <BlogSidebar />
          </div>
        </div>
      </div>
    </article>
  </section>
)

export default BlogOne



// WEBPACK FOOTER //
// ./src/pages/blog/why-is-content-marketing-important.js